import { TYPES_PLANS } from "#/constants";
import { BreadcrumbPropsBase, MyPlanChildrenBreadcrumbProps } from "../types";
import {
  CONTRACT_PREVIOUS,
  DEPENDENTS_PREVIOUS,
  MY_PLAN_PREVIOUS,
  NEW_DEPENDENTS_PREVIOUS,
} from "./previous";

export const MY_PLAN_CHILDRENS_BREADCRUMP: MyPlanChildrenBreadcrumbProps = (
  typePlan,
  pageName
) => ({
  previousPages: [
    MY_PLAN_PREVIOUS(),
    MY_PLAN_PREVIOUS(typePlan as TYPES_PLANS),
  ],
  pageName,
});

export const CONTRACT_CHILDRENS_BREADCRUMP: MyPlanChildrenBreadcrumbProps = (
  typePlan,
  pageName
) => ({
  previousPages: [MY_PLAN_PREVIOUS(typePlan as TYPES_PLANS), CONTRACT_PREVIOUS],
  pageName,
});

export const DEPENDENTS_CHILDRENS_BREADCRUMP: MyPlanChildrenBreadcrumbProps = (
  typePlan,
  pageName
) => ({
  previousPages: [
    MY_PLAN_PREVIOUS(typePlan as TYPES_PLANS),
    DEPENDENTS_PREVIOUS,
  ],
  pageName,
});
export const NEW_DEPENDENTS_CHILDRENS_BREADCRUMP: (
  pageName: string
) => BreadcrumbPropsBase = (pageName) => ({
  previousPages: [DEPENDENTS_PREVIOUS, NEW_DEPENDENTS_PREVIOUS],
  pageName,
});
